export function stringIsNotNullOrWhitespace(value?: string | null): value is string {
  return typeof value === 'string' &&
         value !== undefined &&
         value !== null &&
         value !== ''
}